import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { setChildToken } from '../auth.js'

export default function ChildLogin() {
  const [params] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const code = params.get('code')
    const token = params.get('token') // backward compat

    if (code) {
      // Redeem one-time code
      fetch(`/api/child-device/redeem/${code}`)
        .then(r => r.ok ? r.json() : Promise.reject(r.status))
        .then(data => {
          setChildToken(data.token)
          navigate('/child', { replace: true })
        })
        .catch(() => navigate('/login', { replace: true }))
    } else if (token) {
      // Legacy fallback
      setChildToken(token)
      navigate('/child', { replace: true })
    } else {
      navigate('/login', { replace: true })
    }
  }, [])

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900">
      <p className="text-white text-lg">Laddar barnläge...</p>
    </div>
  )
}
